__turbopack_context__.v({
  "badge": "TakeawayComingSoon-module__J7Vnna__badge",
  "contactButton": "TakeawayComingSoon-module__J7Vnna__contactButton",
  "container": "TakeawayComingSoon-module__J7Vnna__container",
  "description": "TakeawayComingSoon-module__J7Vnna__description",
  "eyebrow": "TakeawayComingSoon-module__J7Vnna__eyebrow",
  "icon": "TakeawayComingSoon-module__J7Vnna__icon",
  "iconWrap": "TakeawayComingSoon-module__J7Vnna__iconWrap",
  "page": "TakeawayComingSoon-module__J7Vnna__page",
  "title": "TakeawayComingSoon-module__J7Vnna__title",
});
